const addAnother = () => {
    const allButtons = document.querySelectorAll('.form-contact__add-another');
    allButtons.forEach(element => {
        const curBut = element;
        const curGroupOfField = curBut.nextElementSibling;
        const curButParent = curBut.parentElement;
        const curParentData = curButParent.dataset.id;

        const dataWithoutLast = curParentData.slice(0, -1);
        const dataLast = parseInt(curParentData.slice(-1), 10) + 1;

        curBut.addEventListener('click', (event) => {
            event.preventDefault();
            curGroupOfField.style.display = 'flex';
            curBut.style.display = 'none';

            if(document.querySelector(`[data-id="${dataWithoutLast + dataLast}"]`)){
                const nextStepCon = document.querySelector(`[data-id="${dataWithoutLast + dataLast}"]`);
                nextStepCon.querySelector('.form-contact__add-another').classList.remove('form-contact__add-another_d-n');
            }

        });
    });
}
module.exports = addAnother;